<template>
    <form @submit="onSave">
        <div :class="IsSubscription ? 'modal-body' : 'col'" style="max-height: 80vh; overflow-y: auto;">
            <div class="row" v-if="!IsUpdate">
                <div class="col-md-4">
                    <div class="input-group mb-3">
                        <input type="text" class="form-control input-sm rounded-end-0" v-model="form.firstName"
                            :placeholder="$t('first') + ' ' + $t('name')" required @input="onNameChange">
                        <span class="input-group-text rounded-start-0"><span class="fas fa-user"></span></span>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="input-group mb-3">
                        <input type="text" class="form-control input-sm rounded-end-0" v-model="form.lastName"
                            :placeholder="$t('last') + ' ' + $t('name')" required @input="onNameChange">
                        <span class="input-group-text rounded-start-0"><span class="fas fa-user"></span></span>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="input-group mb-3">
                        <input type="text" class="form-control input-sm rounded-end-0" v-model="form.displayName"
                            :placeholder="$t('displayName')" required>
                        <span class="input-group-text rounded-start-0"><span class="fas fa-id-card"></span></span>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col">
                    <div class="input-group">
                        <input type="text" class="form-control input-sm rounded-end-0" v-model="form.organizationName"
                            :placeholder="$t('organization') + ' ' + $t('name')" required>
                        <span class="input-group-text rounded-start-0"><span class="fas fa-sitemap"></span></span>
                    </div>
                    <span v-if="form.organizationName && !isOrganizationNameUnique"
                        class="text-danger text-sm">Organization already exists.</span>
                    <br v-if="form.organizationName && !isOrganizationNameUnique && !isOrganizationNameValid">
                    <span v-if="form.organizationName && !isOrganizationNameValid" class="text-danger text-sm">Special
                        charcters are not allowed!</span>
                </div>
            </div>
            <div class="row" v-if="!IsUpdate">
                <div class="col">
                    <div class="input-group mb-3">
                        <input type="email" class="form-control input-sm rounded-end-0" v-model="form.email"
                            :placeholder="$t('email')" :disabled="IsUpdate" required>
                        <span class="input-group-text rounded-start-0"><span class="fas fa-envelope"></span></span>
                    </div>
                </div>
            </div>
            <div class="row" v-if="!IsUpdate">
                <div class="col">
                    <div class="input-group mb-3">
                        <input type="password" class="form-control input-sm rounded-end-0" v-model="form.password"
                            :placeholder="$t('password')" required>
                        <span class="input-group-text rounded-start-0"><span class="fas fa-lock"></span></span>
                    </div>
                </div>
            </div>
            <div class="row" v-if="!IsUpdate">
                <div class="col">
                    <div class="input-group mb-3">
                        <input type="password" class="form-control input-sm rounded-end-0" v-model="form.confirmPassword"
                            :placeholder="$t('retype') + ' ' + $t('password')">
                        <span class="input-group-text rounded-start-0"><span class="fas fa-lock"></span></span>
                    </div>
                </div>
            </div>

            <br v-if="!IsUpdate">
            <div class="row" v-if="!IsUpdate">
                <div class="col">
                    <div class="d-flex align-items-center gap-2">
                        <input class="form-check-input mt-0" type="radio" id="internal" :value="false"
                            v-model="form.useExternalDB" name="internalExternal" checked
                            @change="onChangesuseExternalDB()">
                        <label for="internal" style="cursor: pointer; margin-bottom: 0;">
                            {{ $t('use') + ' ' + $t('internal') + ' ' + $t('database') }}</label>
                    </div>
                </div>
                <div class="col">
                    <div class="d-flex align-items-center gap-2">
                        <input class="form-check-input mt-0" type="radio" id="external" :value="true"
                            v-model="form.useExternalDB" name="internalExternal" @change="onChangesuseExternalDB()">
                        <label for="external" style="cursor: pointer; margin-bottom: 0;">
                            {{ $t('use') + ' ' + $t('external') + ' ' + $t('database') }}</label>
                    </div>
                </div>
            </div>

            <br v-if="!IsUpdate">
            <div v-if="form.useExternalDB && !IsUpdate">
                <div class="row">
                    <div class="col">
                        <div class="input-group mb-3">
                            <select class="form-control input-sm" id="internal" v-model="form.authenticationType"
                                name="authenticationType" @change="resetServerInfo()"
                                style="padding-left: 6px !important;">
                                <option :value="1">SQL Server Authentication</option>
                                <option :value="2">Entra Service Principle Authentication</option>
                            </select>
                            <div class="input-group-append">
                                <div class="input-group-text">
                                    <span class="fas fa-cloud"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <div class="input-group mb-3">
                            <input type="text" v-model="form.sqlServerName" class="form-control input-sm"
                                :required="form.useExternalDB" :placeholder="$t('serverName')">
                            <div class="input-group-append">
                                <div class="input-group-text">
                                    <span class="fas fa-server"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="form.authenticationType == 2">
                    <div class="col">
                        <div class="input-group mb-3">
                            <input type="text" v-model="form.tenantId" class="form-control input-sm"
                                :required="form.useExternalDB && form.authenticationType == 2"
                                :placeholder="$t('tenantId')">
                            <div class="input-group-append">
                                <div class="input-group-text">
                                    <span class="fas fa-cog"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="input-group mb-3">
                            <input type="text" class="form-control input-sm" v-model="form.sqlServerUserName"
                                :required="form.useExternalDB"
                                :placeholder="form.authenticationType == 1 ? $t('serverUserName') : $t('clientId')">
                            <div class="input-group-append">
                                <div class="input-group-text">
                                    <span class="fas fa-server"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="input-group mb-3">
                            <input type="password" class="form-control input-sm" v-model="form.sqlServerPassword"
                                :required="form.useExternalDB"
                                :placeholder="form.authenticationType == 1 ? $t('serverPassword') : $t('clientSecret')">
                            <div class="input-group-append">
                                <div class="input-group-text">
                                    <span class="fas fa-key"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="input-group mb-3" v-if="!isConnectLoader">
                            <button type="button" :disabled="!hasServerInformationToRetrieveDb"
                                @click="onCheckDbConnection()" class="btn btn-block btn-outline-success">
                                {{ $t('fetchDatabases') }}</button>
                        </div>
                        <div class="input-group mb-3" v-if="isConnectLoader && !IsSubscription">
                            <button class="btn btn-block btn-outline-success" type="button" disabled>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Loading...
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="listDatabases.length > 0 && !isConnectLoader">
                    <div class="col">
                        <div class="input-group mb-3">
                            <ejs-dropdownlist id='databaseTree' v-model="form.databaseName" :dataSource='listDatabases'
                                :placeholder='$t("database")'>
                            </ejs-dropdownlist>
                        </div>
                    </div>
                </div>
                <div class="row" v-else>
                    <div class="col">
                        <div class="input-group mb-3">
                            <input type="text" v-model="form.databaseName" class="form-control input-sm"
                                :required="form.useExternalDB" :placeholder="$t('database')">
                            <div class="input-group-append">
                                <div class="input-group-text">
                                    <span class="fas fa-server"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Module Schemas -->
            <div v-if="form.moduleCheckBox?.length > 0 && !isModuleLoader">
                <div class="row mt-2" v-for="(module, index) of listModule" :key="module.id">
                    <div class="col-md-3 d-flex align-items-center gap-2" v-if="form.moduleCheckBox[index]">
                        <input type="checkbox" class="checkbox" v-model="form.moduleCheckBox[index].isChecked" :id="'module' + index">
                        <label :for="'module' + index" class="mb-0">{{ module.displayName }}</label>
                    </div>
                    <div class="col" v-if="form.moduleCheckBox[index]">
                        <input :disabled="!serverInformationProvided || !form.moduleCheckBox[index].isChecked"
                            v-model="form.moduleCheckBox[index].schemaName" class="form-control input-sm" type="text"
                            :placeholder="`${module.displayName} schema`" />
                    </div>
                </div>
            </div>
            <div class="row mt-2 ms-auto" v-if="IsSubscription">
                <span style="font-size: 0.85em;">*{{ `${$t('note')} : ${$t('msgRenameSchema')}` }}</span>
            </div>
            <div v-if="isModuleLoader" class="container-skel">
                <div class="post-skel">
                    <div class="line-skel"></div>
                </div>
                <div class="post-skel">
                    <div class="line-skel"></div>
                </div>
                <div class="post-skel">
                    <div class="line-skel"></div>
                </div>
            </div>
            <div class="row" v-if="form.moduleCheckBox?.length == 0 && !isModuleLoader">
                <div class="alert alert-warning alert-dismissible fade show" role="alert">
                    There is no <strong>modules</strong> to select for subscription. and you can't register without
                    selecting any module.
                    Please contact to the administartor.
                    <button type="button" class="close" data-bs-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
        </div>
        <div :class="IsSubscription ? 'modal-footer' : 'row'" style="position: sticky;bottom: 0; background: white;">
            <button v-if="IsSubscription" type="button" class="btn btn-sm btn-outline-close" @click="close()">
                <i class="fas fa-times"></i>&nbsp;{{ $t('close') }}
            </button>

            <div v-if="IsSubscription">
                <button type="submit" class="btn btn-sm btn-outline-info-reverse">
                    <i class="fas fa-save" v-if="IsSubscription"></i>&nbsp;{{ IsUpdate ? $t('update') : $t('save') }}
                </button>
            </div>

            <div v-if="!IsSubscription && !isRegisterLoader" :class="'col-12 mt-3'">
                <button :disabled="form.moduleCheckBox?.length == 0" type="submit"
                    class="btn-register-main">
                    {{ $t('register') }}
                </button>
            </div>

            <div v-if="!IsSubscription && isRegisterLoader" :class="'col-12'">
                <button class="btn-register-main" type="button" disabled>
                    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    {{ $t('loading') }}...
                </button>
            </div>
        </div>
    </form>
    <input id="subsWiseModulesId" @change="onLoadRegisterAfterSubscribe()" type="hidden" />
</template>

<script lang="ts">
// import './RegisterModalComponent.css'; // Moving styles to style block
import { defineComponent, } from 'vue';
import { DropDownListComponent } from '@syncfusion/ej2-vue-dropdowns';
import { CheckIfDBExistResponse, DbConnectionResponse, RegisterResponse } from './Register.model';
import agent, { masterServiceBaseURL } from '@/services/agent';
import toasterService from '@/services/toasterService';
import authService from '@/services/authService';
import router from '@/router/router';
import { Module, ModuleGetResponse, SchemaResponse } from '../Module/Module.model';
import { Subscription, SubscriptionResponse } from '../Subscription/Subscription.model';
import modal from '@/components/common/modalManage';
import emitter from '@/services/mitt';
import { API_KEY } from './Constants';
import { isEmpty } from 'lodash';

let _registerForm: Subscription = {} as Subscription;
let _databases: string[] = [];
let _moduleData: Module[] = [];

export default defineComponent({
    props: {
        IsSubscription: Boolean,
        IsUpdate: Boolean,
    },
    components: {
        "ejs-dropdownlist": DropDownListComponent
    },
    created() {
        this.classAddRemove();
        agent.setBaseUrl(masterServiceBaseURL);
    },
    data() {
        return {
            listDatabases: _databases,
            form: _registerForm,
            isConnectLoader: false,
            isExternalDBConnectionExist: false,
            isRegisterLoader: false,
            isModuleLoader: false,
            listModule: _moduleData,
            fieldsModule: { text: 'name', value: 'id' },
            dbSchemaList: [] as Array<string>,
            isOrganizationNameUnique: true,
            isOrganizationNameValid: true,
            isOrganizationNameGood: false
        }
    },
    computed: {
        isTestConnectionSucceeded() {
            return this.listDatabases?.length > 0;
        },
        serverInformationProvided() {
            if (!this.form.useExternalDB)
                return true;

            return Boolean(this.form.sqlServerName && this.form.sqlServerUserName && this.form.sqlServerPassword && this.form.databaseName);
        },
        hasServerInformationToRetrieveDb() {
            return this.form.useExternalDB && (this.form.authenticationType == 1 || (this.form.authenticationType == 2 && !isEmpty(this.form.tenantId))) && !isEmpty(this.form.sqlServerName) && !isEmpty(this.form.sqlServerUserName) && !isEmpty(this.form.sqlServerPassword);
        }
    },
    mounted() {
        this.resetRegister();
        this.RedirectTo();
        this.loadModule();

        emitter.on('setForm', form => {
            const getForm = form as Subscription;
            this.form = getForm;
            this.loadModule();
        });
    },
    methods: {
        onCheckDbConnection() {
            let params = {
                sqlServerName: this.form.sqlServerName,
                sqlServerUserName: this.form.sqlServerUserName,
                sqlServerPassword: this.form.sqlServerPassword,
                authenticationType: this.form.authenticationType,
                tenantId: this.form.tenantId,
            };

            if (!this.IsSubscription) {
                this.isConnectLoader = true;
            }

            this.listDatabases = [];
            agent.getAnonymous<DbConnectionResponse>(API_KEY.GET_DB_CONNECTION, params).then((response) => {
                if (response.result) {
                    this.listDatabases = response.result;
                    this.isConnectLoader = false;
                }
            }).catch(() => {
                this.isConnectLoader = false;
            });
        },
        async checkExternalDBConnectionExist(): Promise<boolean> {
            let params = {
                sqlServerName: this.form.sqlServerName,
                sqlServerUserName: this.form.sqlServerUserName,
                sqlServerPassword: this.form.sqlServerPassword,
                authenticationType: this.form.authenticationType,
                databaseName: this.form.databaseName,
                tenantId: this.form.tenantId,
            };
            let isSuccess = false;
            await agent.getAnonymous<CheckIfDBExistResponse>(API_KEY.Check_If_DB_Exist, params).then((response) => {
                console.log(response);
                if (response.result) {
                    isSuccess = true;
                } else {
                    isSuccess = false;
                }
            }).catch(() => {
                isSuccess = false;
            });
            return isSuccess;
        },
        async onSave(event: any) {
            event.preventDefault();

            if (this.IsSubscription && this.IsUpdate) {
                const modules = this.form.moduleCheckBox
                    .filter(m => m.isChecked)
                    .map(m =>
                    ({
                        id: m.id,
                        selected: m.isChecked,
                        schemaName: m.schemaName,
                        name: m.schemaName
                    }));

                const put: Subscription = {
                    ...this.form,
                    modules: modules,
                    modifiedBy: authService.getUserEmail()
                };

                agent.put<SubscriptionResponse>(API_KEY.PUT, put).then((response) => {
                    if (response.result) {
                        this.isRegisterLoader = false;
                        emitter.emit('changeSubscriptions', {})
                    }
                }).catch(() => {
                    this.isRegisterLoader = false;
                });
            } else {

                if (this.form.useExternalDB) {
                    let isExist = await this.checkExternalDBConnectionExist()
                    if (isExist == false) {
                        toasterService.error('Database connection failed or database does not exist in the server.');
                        return;
                    }
                }

                let post = { ...this.form };

                // post.modules = post.moduleCheckBox.filter(i => i.isChecked == true).map(m => m.id);
                post.modules = post.moduleCheckBox
                    .filter(m => m.isChecked)
                    .map(m =>
                    ({
                        id: m.id,
                        selected: m.isChecked,
                        schemaName: m.schemaName,
                        name: m.schemaName,
                    }));

                this.isRegisterLoader = true;
                agent.postAnonymous<RegisterResponse>(API_KEY.REGISTER, post).then((response) => {
                    if (response.result) {
                        if (this.IsSubscription) {
                            this.isRegisterLoader = false;
                            document.getElementById('subsWiseRegister')!.dispatchEvent(new Event('change'));
                        } else {
                            toasterService.success('Subscription created!, Please try login');
                            this.onRedirectSuccess();
                        }
                    }
                }).catch(() => {
                    this.isRegisterLoader = false;
                });
            }
        },
        onLoadRegisterAfterSubscribe() {
            this.resetRegister();
            this.loadModule();
        },
        async loadModule() {
            this.form.moduleCheckBox = [];
            this.isModuleLoader = true;
            const response = await agent.postAnonymous<ModuleGetResponse>(API_KEY.GET_MODULE, {}, false);
            if (response && response.result) {
                this.listModule = response.result.result;

                this.form.moduleCheckBox = this.listModule.map(item => {
                    const module = this.form.modules.find(i => i.id == item.id);

                    return {
                        id: Number(item.id),
                        isChecked: this.form.modules.some(i => i.id == item.id),
                        schemaName: module ? module.schemaName?.toLowerCase() : item.schemaName?.toLowerCase(),
                        isDuplicate: false,
                        isValid: true
                    };
                });
            }
            this.isModuleLoader = false;
        },
        close() {
            modal.Close('subscriptionModal');
        },
        onRedirectSuccess() {
            this.isRegisterLoader = false;
            this.resetRegister();
            this.$router.push("/login");
        },
        resetRegister() {
            this.form = {} as Subscription;
            this.form.databaseName = "";
            this.form.modules = [];
            this.form.moduleCheckBox = [];
            this.form.displayName = "";
            this.form.authenticationType = 1;
        },
        onNameChange() {
            const combined = ((this.form.firstName || '') + ' ' + (this.form.lastName || '')).trim();
            const current = (this.form.displayName || '').trim();
            if (isEmpty(current) || combined.startsWith(current) || current.startsWith(combined)) {
                this.form.displayName = combined;
            }
        },
        onChangesuseExternalDB() {
            this.form.authenticationType = 1;
            this.form.databaseName = "";
            this.form.sqlServerName = "";
            this.form.sqlServerPassword = "";
            this.form.sqlServerUserName = "";
            this.form.tenantId = "";
            this.listDatabases = [];
        },
        resetServerInfo() {
            this.form.databaseName = "";
            this.form.sqlServerName = "";
            this.form.sqlServerPassword = "";
            this.form.sqlServerUserName = "";
            this.form.tenantId = "";
            this.listDatabases = [];
        },
        RedirectTo() {
            if (!this.IsSubscription) {
                const isExpired = authService.isExpired(authService.getToken());
                if (!isExpired) router.push("/");
            }
        },
        classAddRemove() {
            if (!this.IsSubscription) {
                var bodyElement = document.body;
                var sidbarminiClass = bodyElement.classList.contains("sidebar-mini");
                var layoutfixedClass = bodyElement.classList.contains("layout-fixed");
                var registerpageClass = bodyElement.classList.contains("register-page");
                if (sidbarminiClass) bodyElement.classList.remove('sidebar-mini');
                if (layoutfixedClass) bodyElement.classList.remove('layout-fixed');
                if (registerpageClass) bodyElement.classList.remove('register-page');
            }
        },
        loadSchema() {
            if (this.form.useExternalDB) {
                const self = this;
                let params = {
                    sqlServerName: this.form.sqlServerName,
                    sqlServerUserName: this.form.sqlServerUserName,
                    sqlServerPassword: this.form.sqlServerPassword,
                    useInternalDatabase: !this.form.useExternalDB,
                    sqlServerCatalogName: this.form.databaseName,
                    organizationName: this.form.organizationName,
                };

                agent.getAnonymous<SchemaResponse>(API_KEY.GET_SCHEMA, params, false).then(response => {
                    self.dbSchemaList = response.result;
                });
            }
        }
    },
});
</script>

<style scoped>
.btn-register-main {
  height: 52px;
  width: 100%;
  border-radius: 100px;
  background: #03607A;
  color: #ffffff;
  font-weight: 700;
  font-size: 1.05rem;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(3, 96, 122, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-register-main:hover:not(:disabled) {
  background: #024a5f;
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(3, 96, 122, 0.3);
}

.btn-register-main:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.input-group-text {
    background-color: #f8fafc;
    border-color: #e2e8f0;
    color: #94a3b8;
}

.input-group .input-sm:not(:last-child) {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
}
.input-group .input-sm:not(:first-child) {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
}
.input-group .input-group-text:last-child {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
}

.form-control {
    border-color: #e2e8f0;
    background-color: #f8fafc;
}

.form-control:focus {
    border-color: #03607A;
    background-color: #fff;
    box-shadow: 0 0 0 3px rgba(3, 96, 122, 0.1);
}
</style>
